import PropTypes from "prop-types";
import styles from "./CategoryHeader.css";
import CategoryHeaderDescription from "./CategoryHeaderDescription";
import CategoryHeaderLinks from "./CategoryHeaderLinks/CategoryHeaderLinks";
import CategoryHeaderTitle from "./CategoryHeaderTitle";
import { CATEGORY_BANNER_ID } from "../constants";
import CategoryHeaderRibbon from "../CategoryHeaderRibbon";
import { withTranslation } from "../translation";
import shouldShowNewInTodayRibbon from "./shouldShowNewInTodayRibbon";

export const CategoryHeader = ({
  hasHeaderLinks,
  hasVisualCategories,
  category,
  browseCountry,
  formatTranslation
}) => (
  <section id={CATEGORY_BANNER_ID} className={styles.wrapper}>
    <div className={styles.textWrapper}>
      <div className={styles.titleHeaderWrapper}>
        <CategoryHeaderTitle hasVisualCategories={hasVisualCategories} />
        {!hasVisualCategories && (
          <CategoryHeaderDescription device="mobileOnly" />
        )}
        {hasHeaderLinks && <CategoryHeaderLinks />}
      </div>

      {!hasVisualCategories && (
        <CategoryHeaderDescription device="desktopOnly" />
      )}

      {shouldShowNewInTodayRibbon({
        browseCountry,
        loyaltyBenefitType: category.loyaltyBenefit?.type
      }) && (
        <CategoryHeaderRibbon
          ribbonText={formatTranslation("ea_new_in_plp_banner")}
        />
      )}
    </div>
  </section>
);

CategoryHeader.propTypes = {
  hasHeaderLinks: PropTypes.bool.isRequired,
  hasVisualCategories: PropTypes.bool.isRequired,
  browseCountry: PropTypes.string,
  category: PropTypes.shape({
    loyaltyBenefit: PropTypes.shape({
      type: PropTypes.string
    })
  }).isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(CategoryHeader);
